import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero'
import FeatureList from '../../components/Minimal/FeatureList'
import directImg from '../../assets/images/direct.png'

const DirectDepositPage = () => {
  return (
    <div>
      <SimpleHero
        title="Get paid up to 2 days early"
        subtitle="Set up direct deposit for faster, safer paydays—no trips to the branch."
        primaryLabel="Set up direct deposit"
        primaryHref="/DirectDeposit"
        variant="sofi"
        imageSrc={directImg}
        imageAlt="Direct deposit"
        imageOn="right"
        tiltImage
        badges={["Faster paydays","Always secure","Hands‑free"]}
      />
      <FeatureList
        items={[
          { title: 'Faster paydays', desc: 'Access funds up to 2 days early.' },
          { title: 'Always secure', desc: 'Your money moves safely every time.' },
          { title: 'Hands‑free', desc: 'No trips or waiting—arrives automatically.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/download">Download the app</a>
        </div>
      </section>
    </div>
  );
};

export default DirectDepositPage;
